module.exports = "/assets/data/de1dcabff6ce35ebf08cad81e2695aa5-CH64.data.json";